/**
 * ¿Hay un cobro abierto en esta pantalla ahora mismo?
 *
 * Lo pregunta la actualización sola (`AvisoDeVersion`): una recarga en mitad
 * de un cobro se llevaría los pagos a medio anotar, con el cliente delante.
 * La pantalla de cobro (`ModalPago`) se marca mientras está montada, y solo
 * está montada mientras se cobra.
 */

import { useEffect } from "react";

let abiertos = 0;

export function hayCobroEnCurso(): boolean {
  return abiertos > 0;
}

/** Marca un cobro abierto mientras el componente que lo llama esté montado. */
export function useCobroEnCurso(): void {
  useEffect(() => {
    abiertos += 1;
    return () => {
      abiertos = Math.max(0, abiertos - 1);
    };
  }, []);
}
